import React from 'react';
import { Trash2 } from 'lucide-react';

const OrdersDeleteModal = ({ confirmDeleteOrder, deletingOrder, isDeleting, setDeletingOrder, setShowDeleteModal }) => {
  return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4 animate-in fade-in duration-200">
          <div className="bg-gray-800 rounded-2xl w-full max-w-sm border border-gray-600 shadow-2xl animate-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="p-5 text-center">
              <div className="w-16 h-16 bg-gray-700/50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Trash2 className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="text-lg font-bold text-white mb-1">Excluir Pedido</h3>
              <p className="text-sm text-gray-400">#{deletingOrder.order_number}</p>
            </div>

            {/* Conteúdo */}
            <div className="px-5 pb-4">
              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4">
                <p className="text-sm text-yellow-200 text-center">
                  <strong>Atenção:</strong> O pedido será removido da sua lista de pedidos. 
                  O cliente <strong>não será notificado</strong> sobre esta exclusão.
                </p>
              </div>
            </div>

            {/* Footer com botões */}
            <div className="p-4 border-t border-gray-700 flex gap-3">
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setDeletingOrder(null);
                }}
                disabled={isDeleting}
                className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-xl transition-all disabled:opacity-50"
                data-testid="delete-cancel-btn"
              >
                Cancelar
              </button>
              <button
                onClick={confirmDeleteOrder}
                disabled={isDeleting}
                className="flex-1 px-4 py-3 bg-gray-600 hover:bg-gray-500 text-white font-bold rounded-xl transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                data-testid="delete-confirm-btn"
              >
                {isDeleting ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Excluindo...
                  </>
                ) : (
                  <>
                    <Trash2 className="w-4 h-4" />
                    Excluir
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
  );
};

export default OrdersDeleteModal;
